import { Component } from 'react';
import { PasswordValidationChecklistElement } from './password-requirements';
import { observer } from 'mobx-react';
import { injectDependency } from '@servicetitan/react-ioc';
import { CompromizedPasswordStore } from './stores/compromized-password.store';

interface ICompromisedPasswordValidator {
    password: string;
}

@observer
export class CompromisedPasswordValidator extends Component<ICompromisedPasswordValidator> {
    @injectDependency(CompromizedPasswordStore)
    declare private compromizedPasswordStore: CompromizedPasswordStore;

    componentDidUpdate(prevProps: ICompromisedPasswordValidator) {
        if (prevProps.password !== this.props.password) {
            this.compromizedPasswordStore.validate(this.props.password);
        }
    }

    render() {
        const inputFieldsAreEmpty = this.props.password.length === 0;
        const { isValid, isValidating } = this.compromizedPasswordStore;
        return (
            <PasswordValidationChecklistElement
                requirementText="Use an uncommon password"
                isValid={isValid}
                isActive={!inputFieldsAreEmpty}
                isLoading={isValidating}
                tooltip="Avoid using a common password that can be easily guessed, i.e. Password1, Test1234, etc"
            />
        );
    }
}
